import React from 'react'
import { Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

interface EnhancedChartDownloadButtonProps {
    containerSelector: string
    fileNamePrefix: string
    data?: Record<string, unknown>[]
    csvHeaders?: string[]
}

export const EnhancedChartDownloadButton: React.FC<
    EnhancedChartDownloadButtonProps
> = ({ fileNamePrefix, data, csvHeaders }) => {
    const { t } = useTranslation('common')

    const exportChart = () => {
        if (!data || data.length === 0) {
            return
        }

        const currentDate = new Date().toISOString().split('T')[0]
        const fileName = `${fileNamePrefix}_${currentDate}`
        const headers = csvHeaders || Object.keys(data[0])
        const escapeCsvValue = (value: unknown) => {
            const normalizedValue = value == null ? '' : String(value)
            return `"${normalizedValue.replace(/"/g, '""')}"`
        }

        const csvContent = [
            headers.join(','),
            ...data.map((row) =>
                headers
                    .map((header) => escapeCsvValue(row[header]))
                    .join(',')
            ),
        ].join('\n')

        const csvBlob = new Blob([csvContent], {
            type: 'text/csv;charset=utf-8',
        })
        const csvUrl = URL.createObjectURL(csvBlob)
        const link = document.createElement('a')
        link.href = csvUrl
        link.download = `${fileName}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(csvUrl)
    }

    if (!data || data.length === 0) {
        return null
    }

    return (
        <Button icon={<DownloadOutlined />} onClick={exportChart} size="small">
            {t('buttons.exportCsv')}
        </Button>
    )
}
